import * as React from 'react';
import { GenericErrorComponent } from './generic-error-message';
import { userHasIncidentsAccess } from '@utils/user-access-check'
import { navigateType } from '@utils/withRouterWrapper';

interface IErrorBoundaryState {
    error: {},
    errorInfo: string
}
interface IErrorBoundaryProps {
    children?: React.ReactNode;
    navigate?: navigateType;
}
class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            errorInfo: null,
        }
    }

    public componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        })
    }
    public render() {
        if (this.state.errorInfo) {
            return <GenericErrorComponent userAccessCheck={userHasIncidentsAccess} onClick={this.redirectToPrevious} />;
        }
        return this.props.children;
    }
    private readonly redirectToPrevious = () => {
        this.props.navigate(-1);
    }
}

export { ErrorBoundary }
